import {trackers} from 'src/internal/platformMetrics/trackers';

export default {
  trackOrgGlobalsAreaCount: trackers.orgGlobalsAreaCount.track,
  trackBannerCount: trackers.bannerCount.track,
  trackTranslationCount: trackers.translationCount.track,
  translationCountForMessageLength:
    trackers.translationCountForMessageLength.track,
};
